// extracted by mini-css-extract-plugin
export default {"ErrorModal":"Styles_ErrorModal__YemF6","Header":"Styles_Header__mH5o-","Title":"Styles_Title__I3VFO","Paragraph":"Styles_Paragraph__D3tFB"};